/**
 * The published prices, for the pages that explain the plans.
 *
 * These pages are read before anything is bought, so they say the prices as
 * published rather than asking the API, the same way they always said the
 * plan's. What is actually charged comes from the Stripe prices and the
 * catalogue (`therapy_tools.monthly_price_cents`): change a price there and
 * here together — see the repricing migrations `r1e2p3r4i5c6` and
 * `p2r3i4c5e6e7`.
 */

/** Plus, and one centre seat, per month. */
export const PLUS_MONTHLY_CENTS = 1499;

/** Max — Plus with 100 sessions a month instead of 60 — and its seat. */
export const MAX_MONTHLY_CENTS = 2499;

/** Twelve months less this, on the plan and on every module. */
export const ANNUAL_DISCOUNT_PERCENT = 10;

export interface PublishedModule {
    /** The slug the catalogue and the receipt use. */
    slug: string;
    monthlyCents: number;
    /** Catalogue tools that come with it, by slug. */
    includes?: string[];
}

/** What is billed on top of Plus, in the order the pages list it. */
export const PUBLISHED_MODULES: PublishedModule[] = [
    { slug: "ai-insights", monthlyCents: 750 },
    { slug: "alchely-meeting", monthlyCents: 750 },
    { slug: "constellation", monthlyCents: 499, includes: ["genogram-ecomap"] },
    { slug: "emdr", monthlyCents: 499 },
];

/** A year at once, rounded half up — what `pricing.py` charges. */
export const annualCents = (monthlyCents: number): number =>
    Math.floor((monthlyCents * 12 * (100 - ANNUAL_DISCOUNT_PERCENT) + 50) / 100);

/** An amount in minor units, in the reader's language. */
export const formatEuros = (cents: number, language: string): string =>
    new Intl.NumberFormat(language, { style: "currency", currency: "EUR" }).format(cents / 100);
